import { render, staticRenderFns } from "./ProfessionalWill.vue?vue&type=template&id=05636549"
import script from "./ProfessionalWill.vue?vue&type=script&lang=js"
export * from "./ProfessionalWill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports